import React from "react";

import "./styles.scss";

export interface EvaluateCardProps {
  titles: string[];
  questions: string[];
  subtitle: string;
}

const EvaluateCard: React.FC<EvaluateCardProps> = ({
  titles,
  questions,
  subtitle
}) => {
  const numberEmoji = (num: number) => {
    switch (num) {
      case 1:
        return "1️⃣";
      case 2:
        return "2️⃣";
      case 3:
        return "3️⃣";
      case 4:
        return "4️⃣";
      case 5:
        return "5️⃣";
      case 6:
        return "6️⃣";
      case 7:
        return "7️⃣";
      case 8:
        return "8️⃣";
      case 9:
        return "9️⃣";
      default:
        return "";
    }
  };

  return (
    <div className="evaluate-card-container">
      <div className="evaluate-title-container">
        {titles.map((item, index) => (
          <p key={"e-" + index} className="evaluate-title">
            {item}
          </p>
        ))}
      </div>
      <ul>
        {questions.map((question, index) => (
          <li key={"q-" + index}>
            <p>
              {numberEmoji(index + 1)} {question}
            </p>
          </li>
        ))}
      </ul>
      <p>{subtitle}</p>
    </div>
  );
};

export default EvaluateCard;
